import React from 'react';
import { Row, Col, Input, Button } from '../../components/AntDReplacements';

const TextArea = Input.TextArea;
const styles = {
	wrapper: {
		marginTop: '20px',
		marginBottom: '40px',
	},
};
//TODO: Cleanup this styles mess
export const SpecialOffersSection = ({
	specialOffers,
	updateSpecialOffer,
	addSpecialOffer,
	removeSpecialOffer,
}) => (
	<div style={styles.wrapper}>
		<Row>
			<Col>Besondere Angebote / Vergünstigungen, Sonstiges</Col>
		</Row>
		<Row style={{ margin: '10px 0' }}>
			{Object.entries(specialOffers).map(([key, { image, description, title, price }]) => (
				<Col span={7} key={key} style={{ marginBottom: '10px', marginLeft: '10px' }}>
					<Input
						value={title}
						placeholder="Titel..."
						onChange={(event) => updateSpecialOffer(key, 'title', event.target.value)}
					/>
					<Input
						value={price}
						placeholder="Preis..."
						onChange={(event) => updateSpecialOffer(key, 'price', event.target.value)}
					/>
					<TextArea
						value={description}
						placeholder="Beschreibung..."
						onChange={(event) => updateSpecialOffer(key, 'description', event.target.value)}
					/>
					<Input
						value={image}
						placeholder="Bild (Url)..."
						onChange={(event) => updateSpecialOffer(key, 'image', event.target.value)}
					/>
					<Button type="danger" onClick={() => removeSpecialOffer(key)}>
						Löschen
					</Button>
				</Col>
			))}
		</Row>
		<Row>
			<Col>
				<Button type="dashed" icon="plus-circle-o" onClick={() => addSpecialOffer({})} />
			</Col>
		</Row>
	</div>
);
